import {ApplicationRef, Component, ViewChild} from '@angular/core';
import {AlertController, App, Nav, NavController, Platform} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import {UserService} from "../providers/user-service";


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('root') nav: Nav;
  rootPage:any;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    usrService: UserService,
    private alertCtrl: AlertController
  ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      this.rootPage = 'HomePage';

    }).catch((err) => {
      console.log(err);
    });
  }

  private showError(err: any){
    if(!this.alertCtrl){
      return;
    }

    let title = "Ошибка";
    let msg = err;

    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: ['Ok']
    });

    alert.present()
      .catch((err) => {console.log(err);});

    return alert;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts